import Navbar from './Navbar';
import Footer from './Footer';
import FloatingCTA from './FloatingCTA';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white font-sans text-stone-900">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
      <FloatingCTA />
      <Footer />
    </div>
  );
}
